import {  BookCheck, Globe, Pen, Star, User, UserCheck, UserPlus, UserPlus2 } from "lucide-react"
import { IStatisticsProps, StatisticCard } from "./StatisticCard"
import { useEffect, useState } from "react"
import axios from "../../../utils/axios";

export const Statistics = () => {
    const [users, setUsers] = useState([]);

    const [rUsers, setRUsers] = useState(0);

    const [admins, setAdmins] = useState(0);

    useEffect(() => {
        axios.get("/users/all").then(function(res){
            if(res.status === 200){
                setUsers(res.data.data)
            }
        }).catch(function(err){
            console.log(err);
        });
    }, [])

    function countUsers() {
        return users.reduce(
          (acc: any, item: any) => {
            const role = item?.role?.toLowerCase();
      
            if (role === "admin") acc.admins += 1;
            else acc.rUsers += 1;
      
            return acc;
          },
          { admins: 0, rUsers: 0 }
        );
      }

    useEffect(() => {
        if(users.length > 0){
            const userCount = countUsers();
            setAdmins(userCount.admins);
            setRUsers(userCount.rUsers);
        }
    }, [users]);
    
    const data: IStatisticsProps[] = [
        {
            title: "Registered Users",
            description: "0% from last month",
            value: rUsers.toString(),
            StatIcon: <UserCheck className="size-4" />
        },
        {
            title: "Admin Users",
            description: "0% from last month",
            value: admins.toString(),
            StatIcon: <UserPlus className="size-4"/>
        },
        {
            title: "Super Admin Users",
            description: "0% from last month",
            value: "2",
            StatIcon: <UserPlus2 className="size-4"/>
        }
    ]
    return (
        <div className="grid gap-4 md:grid-cols-1 lg:grid-cols-3 mb-2 lg:mb-4">
            {data.map((itm) => {
                return (
                    <StatisticCard StatIcon={itm.StatIcon} title={itm.title} description={itm.description} value={itm.value} key={itm.title} />
                )
            })}
        </div>
    )
}